export default __webpack_public_path__ + "static/pool-forme2-a6b57b684a11c4eecbe78965f88799d3.svg";